export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const apiVersion = process.env.REACT_APP_API_VERSION;
export const businessUploadDocumentMakeAPI =
  "https://hook.us1.make.com/nxewxgzi3lx7ywk44myo7me6qq9216mi";
